import { render } from "./PregnancyVisitModal.vue?vue&type=template&id=3a5165c0&scoped=true"
import script from "./PregnancyVisitModal.vue?vue&type=script&lang=js"
export * from "./PregnancyVisitModal.vue?vue&type=script&lang=js"

import "./PregnancyVisitModal.vue?vue&type=style&index=0&id=3a5165c0&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5165c0"]])

export default __exports__